import { render, staticRenderFns } from "./updateshipments.vue?vue&type=template&id=33317507&"
import script from "./updateshipments.vue?vue&type=script&lang=js&"
export * from "./updateshipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports